import React from "react";
import { Phone } from "lucide-react";
import { FadeUp } from "./Reveal";

const FOUNDER_IMG =
    "https://images.unsplash.com/photo-1601121141461-920cb1993441?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Founder() {
    return (
        <section id="founder" data-testid="founder-section" className="py-24 sm:py-32 bg-obsidian-soft border-y border-gold/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
                <div className="md:col-span-5">
                    <FadeUp>
                        <div className="img-zoom relative border border-gold/30 hover:border-gold-light/60 transition-colors duration-500">
                            <img src={FOUNDER_IMG} alt="Maa Gayatri Jewellers — Kunal" className="w-full h-[440px] md:h-[560px] object-cover" />
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 to-transparent" />
                            <p className="absolute bottom-5 left-6 font-hindi text-gold-light text-lg">माँ गायत्री ज्वेलर्स</p>
                        </div>
                    </FadeUp>
                </div>

                <div className="md:col-span-7">
                    <FadeUp>
                        <p className="eyebrow">The Founder</p>
                        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight">
                            Kunal Diwakar
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.15}>
                        <p className="font-display italic text-2xl sm:text-3xl text-gold-light/90 leading-snug mt-8 max-w-xl">
                            "Trust is the purest metal — we weave it into every piece we make."
                        </p>
                        <p className="text-clay leading-relaxed mt-6 max-w-xl">
                            Under Kunal Diwakar's leadership, Maa Gayatri Jewellers remains the family name
                            Supaul's households rely on. Come by — the chai will be ready for you, and the
                            ornaments shown exactly the way you like.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.25}>
                        <a
                            href="tel:7209661797"
                            data-testid="founder-call-button"
                            className="inline-flex items-center gap-3 mt-9 border border-gold/40 hover:border-gold-light hover:shadow-[0_0_35px_rgba(212,175,55,0.25)] px-7 py-3.5 text-sm font-semibold tracking-wide text-gold-light transition-all duration-300"
                        >
                            <Phone size={15} strokeWidth={2.4} />
                            Talk to Kunal directly — 7209661797
                        </a>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
